import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { deepEqual, isB2B } from '../../../utilities/helpers';
import { pushEvent } from "../../../utilities/analytics";
import { MYFAVORITES_SAVE_EVENT, MYFAVORITES_REMOVE_EVENT } from "../../../constants/analyticEvents";
import { selectSearch } from '../../mainFilter/searchSlice';
import { useGetUserFavoritesQuery, useAddUserFavoriteMutation, useRemoveUserFavoriteMutation } from '../../favorite/rtkFavoriteSlice';
import { getParamFromUrl } from '../../../utilities/urlResolver';
import AddToProposal from '../DealItemExperimental/AddToProposal';
import DeleteFromProposal from './DeleteFromProposal';

export default function LocationIcons({
  onSettingsClick,
  showSettingsBtn,
  hideSettings,
  dealItem,
  type,
  position,
}) {
  const getFavoriteDeal = () => {
    return favorites?.find((offer) => (
      offer.offerId === dealItem.offer.hfOfferId &&
      dealItem.offer.capacity_from_filter &&
      deepEqual(offer.capacity, dealItem.offer.capacity_from_filter)
    ));
  };

  const userContext = JSON.parse(localStorage.getItem('hf_user'));
  const muid = userContext?.user?.muid;
  const isAuthorized = userContext?.user?.user_auth;
  const { data: favorites } = useGetUserFavoritesQuery(muid, {
    skip: !isAuthorized || isB2B(),
  });

  const favoriteDeal = getFavoriteDeal();
  const hfOfferId = dealItem?.offer.hfOfferId;
  const [isLiked, setIsLiked] = useState(!!favoriteDeal);
  const { who } = useSelector(selectSearch);

  useEffect(() => {
    setIsLiked(!!favoriteDeal);
  }, [favoriteDeal])

  const [addToFavorites] = useAddUserFavoriteMutation();
  const [removeFromFavorites] = useRemoveUserFavoriteMutation();

  const doAddToFavorites = async () => {
    setIsLiked(true);
    const offer = {
      offerId: hfOfferId,
      capacity: {
        adult: who.adults,
        child: who.children,
        room: who.rooms,
        childAges: who.childAges,
      }
    }
    const fromwhere = getParamFromUrl('fromwhere');
    if (fromwhere && fromwhere.length) {
      offer.airports = (typeof fromwhere === 'string') ? [fromwhere] : fromwhere;
    }

    try {
      await addToFavorites({
        muid,
        body: offer
      }).unwrap();
    } catch (error) {
      setIsLiked(false);
    }

    pushEvent(MYFAVORITES_REMOVE_EVENT, dealItem);
  }

  const doRemoveFromFavorites = () => {
    setIsLiked(false);
    removeFromFavorites({
      muid,
      favoriteId: favoriteDeal?.id
    });
    pushEvent(MYFAVORITES_SAVE_EVENT, dealItem);
  }

  const handleLikeClick = () => {
    if (!hfOfferId) return console.error('no hfOfferId');

    const userContext = JSON.parse(localStorage.getItem('hf_user'));
    if (userContext && userContext?.user?.userLevel === 'USER_EMAIL' && userContext?.user?.user_auth) {
      if (isLiked) {
        doRemoveFromFavorites();
      } else {
        doAddToFavorites();
      }
    } else if (typeof openLoginModal !== 'undefined') {
      // eslint-disable-next-line no-undef
      openLoginModal("Favorites on card");
    } else {
      window.jQuery('#loginModal').modal('show');
    }
  };

  return (
    <div className="location-icons">
      {!hideSettings && (
        <div
          className={`location-icons-wrap ${showSettingsBtn ? 'settings' : ''}`}
          onClick={onSettingsClick}
        >
          <i className="ri-equalizer-line" />
        </div>
      )}

      {!isB2B() && (
        <div className="location-icons-wrap" onClick={handleLikeClick}>
          <i className={isLiked ? 'ri-heart-fill red' : 'ri-heart-line'} />
        </div>
      )}

      {isB2B() && type !== 'proposals-list' && (
        <AddToProposal offer={dealItem.offer} />
      )}

      {isB2B() && type === 'proposals-list' && (
        <>
          <div className="location-icons-wrap">
            <span className="font-semibold text-tertiary">{position + 1}</span>
          </div>
          {!window.location.href.includes('b2bcustomerview') && (
            <DeleteFromProposal offerId={dealItem.offer.hfOfferId} />
          )}
        </>
      )}
    </div>
  );
}
